import request from '@/utils/request_for_data-workers'
//获取任务处理结果
export function getTaskResult(data = {}) {
  return request.GET('/workers/workers-task/get-task-result', data)
}
//导出列表数据
export function createExportTask(data = {}) {
  return request.PUT('/workers/workers-task/create-export-task', data)
}
